import './utils/rem'; // 必须在样式之前引入，先确定 rem 基准
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/styles/global.scss';
import './utils/scrollAnim'; // .aw-anim 元素进入视口才播放动画
import router from './router'
import Layout from './Layout/index.vue';

Vue.use(ElementUI);

new Vue({
  el: '#app',
  router,
  render: h => h(Layout)
});
